package fr.frux.shared.domain.model

/** Motif de sollicitation ; sert uniquement à choisir la phrase affichée. */
enum class SupportReason { CONTRIBUTION, HARVEST }

/** `INLINE` : paliers dans la feuille (web). `LINK_OUT` : un bouton, sans montant (builds store). */
enum class SupportVariant { INLINE, LINK_OUT }

/**
 * Sollicitation décidée par le serveur (spec 2026-08-13). Le client n'en dérive aucune règle : il
 * affiche ce qui est là, et rien s'il n'y a rien.
 */
data class SupportPrompt(
    val reason: SupportReason,
    val variant: SupportVariant,
    val donateUrl: String,
)
